import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_11: FaireProductEntity = {
  token: "atc_refined_moma_11",
  type: "product",
  name: "Colorful Tableware Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5a18040f5b86dd8f93ebb07cbe640653b9299ac578ad273d1061eda0bfb94c3d.webp",
  priceDollars: 44,
  msrpDollars: 70,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
